// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".brain-cardiovascular-survey .th-td-style {\n  vertical-align: middle !important;\n}\n.brain-cardiovascular-survey .th-style {\n  background: #EEEEEE !important;\n  font-weight: 700;\n  width: 100%;\n}\n.brain-cardiovascular-survey .td-style {\n  width: 16.6%;\n}\n.brain-cardiovascular-survey .etc-info {\n  display: inline-block;\n  float: right;\n}", ""]);
// Exports
module.exports = exports;
